import { TranslateDetail } from ".";

export class Translate{
    id: string;
    url: string;
    translations: TranslateDetail[];
}
